import {get} from 'lodash';
import axios from './axios';
import {HINTS_BASE_URL} from '../config/api';


export const getDeliveryOptionsRequest = async () => {
  const res = await axios.get(`${HINTS_BASE_URL}config/address/radius`);

  const result = get(res, 'data.data', null);
  if (!result) console.log('Delivery options not received');

  return result;
};



// WEBPACK FOOTER //
// ./src/services/index.js